var render = function render(_c,_vm){return _c('div',{staticClass:"HorizontalField field is-horizontal"},[_c('div',{staticClass:"field-label",class:[`is-${_vm.props.labelType}`]},[_vm._t("label")],2),_c('div',{staticClass:"field-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }